import { FetchContext } from '../fetch-context';
import { Questionnaire } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getQuestionnaire: (
  fetchContext: FetchContext,
  questionnaireId: number,
  accessToken?: string,
) => Promise<Questionnaire> = (fetchContext, questionnaireId, accessToken) => fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Questionnaire>(fetchContext.errorStore, response, 'get questionnaire'));
